import { render, staticRenderFns } from "./add-update-pop.vue?vue&type=template&id=5c7689e2&scoped=true"
import script from "./add-update-pop.vue?vue&type=script&lang=js"
export * from "./add-update-pop.vue?vue&type=script&lang=js"
import style0 from "./add-update-pop.vue?vue&type=style&index=0&id=5c7689e2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7689e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c7689e2')) {
      api.createRecord('5c7689e2', component.options)
    } else {
      api.reload('5c7689e2', component.options)
    }
    module.hot.accept("./add-update-pop.vue?vue&type=template&id=5c7689e2&scoped=true", function () {
      api.rerender('5c7689e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/matter-logs/add-update-pop.vue"
export default component.exports